import { ReactNode } from 'react'

import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@/core/hooks/useAuth'

interface ProtectedRouteProps {
	children: ReactNode
	requireAuth?: boolean
	redirectTo?: string
}

/**
 * A wrapper component for routes that require authentication
 * If requireAuth is true, redirects to login if not authenticated
 * If requireAuth is false, redirects to dashboard if already authenticated
 */
export const ProtectedRoute = ({
	children,
	requireAuth = true,
	redirectTo,
}: ProtectedRouteProps) => {
	const { isAuthenticated, isInitialized } = useAuth()
	const location = useLocation()

	// Show nothing while checking authentication
	if (!isInitialized) {
		return null
	}

	// Handle authenticated routes
	if (requireAuth) {
		if (!isAuthenticated) {
			return (
				<Navigate
					to={redirectTo || '/login'}
					state={{ from: location.pathname }}
					replace
				/>
			)
		}

		return <>{children}</>
	}

	// Handle routes that require user to be logged out (like login page)
	if (isAuthenticated) {
		return <Navigate to={redirectTo || '/dashboard'} replace />
	}

	return <>{children}</>
}
